<template>
    <div class="pay-step3">
        <div class="order-info">
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">创建时间</div>
                    <div class="cell-value">{{order.create_time}}</div>
                </div>
                <div class="cell">
                    <div class="cell-title">结算批次号</div>
                    <div class="cell-value">{{order.order_no}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">支付总金额（元)</div>
                    <div class="cell-value">{{order.pay_total}}</div>
                </div>
                <div class="cell">
                    <div class="cell-title">结算状态</div>
                    <div class="cell-value">{{statusList[order.status]}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">结算金额(元)</div>
                    <div class="cell-value">{{order.settlement_money}}</div>
                </div>
                <div class="cell">
                    <div class="cell-title">结算笔数</div>
                    <div class="cell-value">{{order.score}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">服务费用(元)</div>
                    <div class="cell-value">{{order.service_fee}}</div>
                </div>
                <div class="cell">
                    <div class="cell-title">代缴个税(元)</div>
                    <div class="cell-value">{{order.tax}}</div>
                </div>
            </div>
        </div>
        <el-form ref="form" class="pay-form" :model="form" label-width="80px">
            <el-form-item label="支付金额">
                <el-input v-model="order.pay_total" disabled></el-input>
            </el-form-item>
            <el-form-item label="支付密码">
                <el-input class="login-form__input" v-model="form.pay_password" placeholder="请输入密码"
                          type="password"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="paySubmit">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'Step3',
    data () {
        return {
            statusList: ['待支付', '支付成功', '支付失败', '已完成'],
            order: {},
            form: {
                pay_password: ''
            }
        }
    },
    mounted () {
        this.getOrder()
    },
    methods: {
        getOrder () {
            this.order = JSON.parse(window.localStorage.getItem('CURRENT_ORDER'))
        },
        paySubmit () {
            if (!this.order.payment_id) {
                this.$message.error('订单状态错误，请重新创建')
                localStorage.removeItem('CURRENT_ORDER')
                router.push('/index/pay/home')
            } else if (!this.form.pay_password) {
                this.$message.error('请填写支付密码')
            } else {
                this.$http.post('/api/user/payment/pay', qs.stringify({
                    payment_id: this.order.payment_id,
                    pay_password: this.form.pay_password
                }))
                    .then(res => {
                        if (res.code === 0) {
                            router.replace('/index/pay/tips')
                            localStorage.removeItem('CURRENT_ORDER')
                        } else {
                            this.$message.warning(res.message)
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";

    .order-info {
        margin-top: 40px;
        padding: 0 40px;
    }

    .pay-form {
        width: 410px;
        margin: 53px auto;
    }

    .cell-group {
        display: flex;
        border-right: 1px solid #ebeef5;

        .cell {
            flex: 1;
            border-bottom: 1px solid #ebeef5;
            border-left: 1px solid #ebeef5;
            display: flex;
            align-items: center;
            color: #333333;

            .cell-title {
                background-color: #f5f5fa;
                flex: 1;
                padding: 17px 20px;
            }

            .cell-value {
                flex: 1;
                padding: 17px 20px;
                max-width: 50%;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        &:first-child {
            border-top: 1px solid #ebeef5;
        }
    }
</style>
